var slice = require('../array/virtual/slice');

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.slice;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.slice) ? slice : own;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/instance/slice.js
// module id = 440
// module chunks = 0